import { InjectionToken } from '@angular/core';

export const SERVICE_URL = new InjectionToken<string>('SERVICE_URL');

export const SERVICE_PCP_URL = new InjectionToken<string>('SERVICE_PCP_URL');

export const SERVICE_GET_PCP_URL = new InjectionToken<string>('SERVICE__GET_PCP_URL');

export const SERVICE_MEMBER_URL = new InjectionToken<string>('SERVICE_MEMBER_URL');

export const SERVICE_SUBSCRIPTION_KEY = new InjectionToken<string>('SERVICE_SUBSCRIPTION_KEY');

export const SERVICE_API_VERSION = new InjectionToken<string>('SERVICE_API_VERSION');

export const SERVICE_API_KEY = new InjectionToken<string>('SERVICE_API_KEY');

export const SERVICE_CONSUMER_PROFILE_URL  = new InjectionToken<string>('SERVICE_CONSUMER_PROFILE_URL');

export const SERVICE_PROVIDER_SITE_MAP_AUTH_URL  = new InjectionToken<string>('SERVICE_PROVIDER_SITE_MAP_AUTH_URL');

export const AZURE_MAP_CLIENT_ID  = new InjectionToken<string>('AZURE_MAP_CLIENT_ID');
